import React, { useState, useRef } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import styles from './WordleGame.module.css';
import Header from '../components/Header';
import SettingsModal from '../components/modals/SettingsModal';
import { useNavigate, useSearchParams } from 'react-router-dom';
import WordleBoard from './wordle/WordleBoard';

const WordleGame = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const seed = searchParams.get('seed');

  // 공유받은 문제를 끝낸 뒤 새 문제로 넘어갈 때 호출된다.
  // URL 에 ?seed= 가 남아 있으면 계속 같은 문제만 나오므로 지워준다.
  const clearSeed = () => setSearchParams({}, { replace: true });

  const [showGameListModal, setShowGameListModal] = useState(false);
  const [showRulesModal, setShowRulesModal] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showRestartModal, setShowRestartModal] = useState(false);

  const boardRef = useRef();

  const handleShare = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setShowShareModal(true);
    } catch (err) {
      alert('링크 복사에 실패했어요. 주소창의 URL을 직접 복사해주세요!');
      console.error('클립보드 복사 실패:', err);
    }
  };

  const handleRestart = () => {
    if (boardRef.current) {
      boardRef.current.resetGame();
      setShowRestartModal(false);
    }
  };

  return (
    <div className={styles.container}>
      <Header
        title={t('games.wordle.title')}
        onGameList={() => setShowGameListModal(true)}
        onRules={() => setShowRulesModal(true)}
        onSettings={() => setShowSettingsModal(true)}
        onRestart={() => setShowRestartModal(true)}
      />

      <div className={styles.gameContainer}>
        <WordleBoard ref={boardRef} seed={seed} onClearSeed={clearSeed} />
      </div>

      {showGameListModal && (
        <div className="modal-overlay">
          <div className="modal">
            <p>{t('modals.gameList.message')}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowGameListModal(false)}>
                {t('modals.confirm.cancel')}
              </button>
              <button onClick={() => navigate('/')}>
                {t('modals.confirm.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showRulesModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>{t('games.wordle.rules.title')}</h2>
            <p style={{ whiteSpace: 'pre-line' }}>
              {t('games.wordle.rules.description')}
            </p>
            <div className="modal-buttons">
              <button onClick={() => setShowRulesModal(false)}>
                {t('modals.rules.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showSettingsModal && (
        <SettingsModal
          onClose={() => setShowSettingsModal(false)}
          onContact={() => {
            setShowSettingsModal(false);
            setShowContactModal(true);
          }}
          onShare={handleShare}
        />
      )}

      {showContactModal && (
        <div className="modal-overlay">
          <div className="modal">
            <p>{t('modals.contact.message')}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowContactModal(false)}>
                {t('modals.contact.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showShareModal && (
        <div className="modal-overlay">
          <div className="modal share-modal">
            <p>{t('modals.share.message')}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowShareModal(false)}>
                {t('modals.share.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showRestartModal && (
        <div className="modal-overlay">
          <div className="modal">
            <p>{t('modals.restart.message')}</p>
            <div className="modal-buttons">
              <button onClick={() => setShowRestartModal(false)}>
                {t('modals.confirm.cancel')}
              </button>
              <button onClick={handleRestart}>
                {t('modals.confirm.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WordleGame;
